<template>
  <div class="panel">
    <div class="panel-head">
      <div class="panel-title">{{ $t('chi79') }}</div>
      <span class="unit">{{ $t('chi80') }}</span>
    </div>
    <div class="panel-body">
      <template v-if="hoursList.length > 0">
        <div class="chart-row">
          <div class="y-axis">
            <span :style="{ bottom: axisPos(1) }">{{ niceMax }}</span>
            <span :style="{ bottom: axisPos(0.5) }">{{ niceMax / 2 }}</span>
            <span :style="{ bottom: axisPos(0) }">0</span>
          </div>
          <div class="bars-wrap">
            <div class="gridline" :style="{ bottom: axisPos(1) }"></div>
            <div class="gridline" :style="{ bottom: axisPos(0.5) }"></div>
            <div class="bars" :style="{ gap: barGap + 'px' }">
              <div v-for="(v, i) in hoursList" :key="i" class="bar-wrap">
                <div class="bar" :style="{ height: (v / max * 220) + 'px' }" :title="`${trend[i].date}: ${v} ${$t('chi106')}`"></div>
                <div class="bar-label">{{ showLabel(i) ? dayLabel(i) : '' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="chart-note">
          <span>{{ trend[0].date }} ~ {{ trend[trend.length - 1].date }}</span>
          <span>{{ $t('chi81') }}：{{ max }} {{ $t('chi106') }}/{{ $t('chi156') }}</span>
        </div>
      </template>
      <div v-else class="empty">{{ $t('chi9') }}</div>
    </div>
  </div>
</template>

<script>
import { secToHours } from "./statUtils.js";

export default {
  name: "DailyTrendChart",
  props: {
    // getDeviceBootLog 返回的 daily_trend: [{date, runtime(秒)}]
    trend: { type: Array, default: () => [] },
  },
  computed: {
    hoursList() {
      return this.trend.map((t) => secToHours(t.runtime));
    },
    max() {
      return Math.max(...this.hoursList, 0);
    },
    // 天数多时缩小柱间距，避免占满容器导致柱子被压缩到不可见
    barGap() {
      const n = this.hoursList.length;
      if (n <= 45) return 6;
      if (n <= 90) return 3;
      return 2;
    },
    // Y 轴刻度上限：向上取偶数，保证半值刻度为整数
    niceMax() {
      const m = this.max;
      if (m <= 0) return 2;
      let n = 2;
      while (n < m) n += 2;
      return n;
    },
  },
  methods: {
    // 刻度位置：柱区基线在容器底部 2px 处，柱高满值 220px
    axisPos(f) {
      return `calc(2px + ${f} * 220px)`;
    },
    showLabel(i) {
      return i % 3 === 0 || i === this.hoursList.length - 1;
    },
    dayLabel(i) {
      return Number(String(this.trend[i].date).slice(-2));
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.unit {
  color: #8ca0af;
  font-size: 12px;
}
.panel-body {
  padding: 18px;
}
.chart-row {
  display: flex;
}
.y-axis {
  position: relative;
  width: 30px;
  flex-shrink: 0;
}
.y-axis span {
  position: absolute;
  right: 10px;
  transform: translateY(50%);
  font-size: 11px;
  line-height: 1;
  color: #8da0b0;
}
.bars-wrap {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
}
.gridline {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px dashed #e3eef4;
  z-index: 0;
  pointer-events: none;
}
.bars {
  flex: 1;
  height: 250px;
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 12px 8px 2px;
  border-bottom: 1px solid #dce9ef;
  overflow-x: auto; /* 区间过长时横向滚动，保证每根柱子可见 */
  overflow-y: hidden;
}
.bar-wrap {
  flex: 1 1 0;
  min-width: 8px; /* 防止柱子被压缩到 0 宽度 */
  text-align: center;
}
.bar {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 38px;
  margin: 0 auto;
  border-radius: 8px 8px 2px 2px;
  background: linear-gradient(180deg, #55cef1, #24afe6);
  min-height: 5px;
  transition: 0.2s;

  &:hover {
    filter: brightness(0.95);
    transform: translateY(-2px);
  }
}
.bar-label {
  font-size: 11px;
  color: #8da0b0;
  margin-top: 7px;
  overflow: hidden;
  white-space: nowrap;
}
.chart-note {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: #8da0b0;
  font-size: 12px;
  gap: 10px;
}
.empty {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>
